import { useQuery } from '@tanstack/react-query';
import {
  fetchPolicyContent,
  fetchPolicySlugs,
} from '@/features/policies/api/policyApi';
import { queryKeys } from '@/shared/lib/query/queryKeys';

export function usePolicySlugsQuery() {
  return useQuery({
    queryKey: queryKeys.policies.slugs(),
    queryFn: fetchPolicySlugs,
    refetchOnWindowFocus: false,
  });
}

export function usePolicyContentQuery(slug?: string | null) {
  return useQuery({
    queryKey: queryKeys.policies.content(slug || ''),
    queryFn: () => fetchPolicyContent(slug!),
    enabled: Boolean(slug),
    refetchOnWindowFocus: false,
  });
}
